export type ComboboxEntry = {
  text: string;
  value: string;
};

type OptionsProps = {
  options: ComboboxEntry[] | undefined;
};

export const Options = ({ options }: OptionsProps) => {
  return (
    <>
      {options &&
        options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.text}
          </option>
        ))}
    </>
  );
};
